import moment from 'moment'
import { isArray, isUndefined } from 'lodash'

import { getMax, propagate } from '../../../utils/arrayUtils'

export const getXCoordinates = (data, tablePeriods) => {
  const tableStartYear = moment(tablePeriods[0]).year()
  const tableStartWeek = moment(tablePeriods[0]).week()
  const startYear = moment(data.startDate).year()
  const startWeek = moment(data.startDate).week()
  const duration = moment(data.endDate).diff(moment(data.startDate), 'weeks')

  const start = (startWeek + ((startYear - tableStartYear) * 52)) - (tableStartWeek === 1 && (startYear - tableStartYear) === 1 ? 52 : tableStartWeek)
  const end = start + duration

  return [start, end]
}

export const getYCoordinates = (data, matrix, xCoordinates = [0, 0], offset = 0) => {
  const xStart = xCoordinates[0] < 0 ? 0 : xCoordinates[0]
  const xEnd = xCoordinates[1] >= matrix[0].length - 1 ? matrix[0].length - 1 : xCoordinates[1]
  const height = data.total > 0 ? (data.total - 1) : 0

  for (let i = offset; i <= matrix.length; i++) {
    const localHeigth = matrix[i + height] === undefined ? matrix.length - i - 1 : height

    if (matrix[i] === undefined || isCandidate(matrix, i, i + localHeigth, xStart, xEnd)) {
      return [i, i + height]
    }
  }

  return [offset, offset + height]
}

/** @TODO use dicotomic algorithme in place of this */
const isCandidate = (matrix, yStart, yEnd, xStart, xEnd) => {
  return (
    matrix[yStart][xStart] === 0 && matrix[yStart][xEnd] === 0 && matrix[yEnd][xStart] === 0 && matrix[yEnd][xEnd] === 0 &&
    isEmptySubMatrix(matrix, yStart, yEnd, xStart, xEnd)
  )
}

export const isEmptySubMatrix = (matrix, rowStart, rowEnd, colStart, colEnd, ignoredValue = 0) => {
  for (let iRow = rowStart; iRow <= rowEnd; iRow++) {
    if (matrix[iRow] === undefined) return false

    for (let iCol = colStart; iCol <= colEnd; iCol++) {
      if (matrix[iRow][iCol] !== 0 && matrix[iRow][iCol] !== ignoredValue) {
        return false
      }
    }
  }

  return true
}

export const getDisplacement = (start, end, cellSize) => {
  return Math.round((end - start) / cellSize)
}

export const getOverlaps = (matrix, x, y) => {
  const xStart = x[0] < 0 ? 0 : x[0]
  const overlapMap = {}

  for (let iRow = y[0]; iRow <= y[1]; iRow++) {
    if (matrix[iRow] === undefined) break

    for (let iCol = xStart; iCol <= x[1]; iCol++) {
      if (matrix[iRow][iCol] !== 0 && !overlapMap[matrix[iRow][iCol]]) {
        overlapMap[matrix[iRow][iCol]] = true
      }
    }
  }

  return overlapMap
}

export const cellDisplacement = (baseMatrix, data, cell) => {
  const dataPerAlias = data.reduce((acc, item) => {
    acc[item.alias] = item

    return acc
  }, {})

  const aliasToCheck = [cell.alias]
  const newPositions = {}
  const depth = new Array(baseMatrix[0].length).fill(cell.y[0])

  while (aliasToCheck.length > 0) {
    const alias = aliasToCheck.shift()
    const item = alias === cell.alias ? cell : dataPerAlias[alias]

    if (!isUndefined(item)) {
      let offset = getMax(depth, item.x[0], item.x[1])

      if (alias !== cell.alias) {
        offset++
      }

      const location = {
        x: item.x,
        y: [offset, item.y[1] - item.y[0] + offset]
      }

      const foundAlias = getOverlaps(baseMatrix, location.x, location.y)

      newPositions[alias] = location
      propagate(depth, location.x[0], location.x[1], item.y[1] - item.y[0] + offset)
      Object.keys(foundAlias).forEach(a => {
        if (!newPositions[a]) {
          aliasToCheck.push(Number(a))
        }
      })
    }
  }

  return newPositions
}

export const getSwimlaneHeight = (lines, overflows, key) => {
  const candidates = lines.reduce((acc, line) => {
    if (line.id === -1) {
      acc[-1] = line.places
    } else if (line.id === key) {
      acc[key] = line.places
    }

    return acc
  }, {})
  const places = isUndefined(candidates[key]) ? candidates[-1] : candidates[key]
  const overflow = isUndefined(overflows[key]) ? overflows[-1] : overflows[key]

  return places + overflow
}

export const getColumnKey = (column) => {
  let key = column.id || column.title

  if (isArray(key)) {
    key = key.toString()
  }

  return key
}
